import {defineAsyncComponent} from 'vue';

const SelectFeesDIPopup = defineAsyncComponent(() =>
  import('@/views/estimate/feesEstimate/revenueFees/popup/RevenueFeesDIPopup.vue'),
);

const EstimateFees = defineAsyncComponent(() => import('@/views/estimate/feesEstimate/EstimateFeesTab.vue'));

const EstimateRevenueOther = defineAsyncComponent(() =>
  import('@/views/estimate/revenueOtherEstimate/EstimateRevenueOtherTab.vue'),
);
const AddEstimateRevenueOtherPopup = defineAsyncComponent(() =>
  import('@/views/estimate/revenueOtherEstimate/popup/AddEstimateRevenueOtherPopup.vue'),
);
const AddDictionaryRevenueOtherPopup = defineAsyncComponent(() =>
  import('@/views/estimate/revenueOtherEstimate/popup/AddDictionaryRevenueOtherPopup.vue'),
);

const FeesRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimate/feesEstimate/expenseFees/popup/RegularPopup.vue'),
);

const SettingContentLoanRepaymentPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estimateLoanRepayment/SettingContentLoanRepaymentPopup.vue'),
);

const EstimateAddContentPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/baseEstimate/EstimateAddContentPopup.vue'),
);
const EstimateArrgrateAddContentPopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/baseEstimateArrgrate/EstimateArrgrateContentPopup.vue'
  ),
);
const EstimateSectorWideAddContentPopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/baseEstimateSectorWide/EstimateSectorWideContentPopup.vue'
  ),
);
const EstimateThreeYearAddContentPopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/baseEstimate/EstimateThreeYearAddContentPopup.vue'
  ),
);
const EstimateTYAddContentPopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/threeYearEstimate/popup/EstimateTYAddContentPopup.vue'
  ),
);

const EstimateArrgrateAddOrganizationPopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName:'EstimateAddContentPopup'*/ '@/views/estimate/baseEstimateArrgrate/EstimateArrgrateAddOrganizationPopup.vue'
  ),
);
const FeesExpenseInvestPopup = defineAsyncComponent(() =>
  import('@/views/estimate/feesEstimate/expenseFees/popup/ExpenseInvestPopup.vue'),
);
const SelectEstimateInformationPopup = defineAsyncComponent(() =>
  import('@/views/estimate/popups/SelectEstimateInformationPopup.vue'),
);
const SelectEstInitialInformationPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/SelectEstInitialInformationPopup.vue'),
);
const DescribeHelperPopup = defineAsyncComponent(() =>
  import('@/views/estimate/describe/DescribeHelperPopup.vue'),
);
const templateShowValueTable = defineAsyncComponent(() =>
  import('@/views/estimate/describe/TemplateShowValueTable.vue'),
);

const WorkbookEditData = defineAsyncComponent(() => import('@/views/workbook/WorkbookEditData.vue'));

const estimateBudgetDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateBudget/EstimateBudgetDetail.vue'),
);

const estimateBudgetDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateBudget/EstimateBudgetDetailPopup.vue'),
);

const SelectBusinessDIPopup = defineAsyncComponent(() =>
  import('@/views/estimate/businessEstimate/revenueBusiness/popup/RevenueBusinessDIPopup.vue'),
);

const EstimateExpenseBusiness = defineAsyncComponent(() =>
  import('@/views/estimate/businessEstimate/EstimateExpenseBusinessTab.vue'),
);

const estimateSubmitDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/EstimateSubmitDetailPopup.vue'),
);

const estimateThreeYearSubmitDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/estimateThreeYearSubmit/EstimateThreeYearSubmitDetailPopup.vue'),
);
const ThreeYearEstimateProjectExpenseDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/CreateEstimate/ThreeYearEstimateProjectExpenseDetailPopup.vue'),
);

const ThreeYearEstimateSTCProjectExpense = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/createEstimate/estimateProject/ThreeYearEstimateSTCProjectExpense.vue'),
);

const ThreeYearEstimateSTCBugdetCollection = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/createEstimate/budgetCollection/ThreeYearEstimateSTCBugdetCollection.vue'),
);

const esitmateSubmitFeedback = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/EstimateSubmitFeedback.vue'),
);
const EstimateSubmitRecNotifySuperiorPopup = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/EstimateSubmitRecNotifySuperiorPopup.vue'),
);

const EstimateSubmitInitialNotifyPopup = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/EstimateSubmitInitialNotifyPopup.vue'),
);

const EstimateSubmitThreeYearNotiPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/estimateThreeYearSubmit/EstimateSubmitThreeYearNotiPopup.vue'),
);

const EstimateSubmitFeedbackGeneralPopup = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/EstimateSubmitFeedbackGeneralPopup.vue'),
);

const EstimateThreeYearSubmitFeedbackGeneralPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/estimateThreeYearSubmit/EstimateThreeYearSubmitFeedbackGeneralPopup.vue'),
);

const AuditSuperiorFeedbackPopup = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/AuditSuperiorFeedback.vue'),
);
const BusinessRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimate/businessEstimate/expenseBusiness/popup/ExpenseRegularPopup.vue'),
);

const BusinessExpenseInvestPopup = defineAsyncComponent(() =>
  import('@/views/estimate/businessEstimate/expenseBusiness/popup/ExpenseInvestPopup.vue'),
);
const SubmitDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateSubmit/baseSubmit/SubmitDetailPopup.vue'),
);
const UnitInfomationPopup = defineAsyncComponent(() => import('@/views/system/UnitInfomationPopup.vue'));
const ExamineSectorWideDetailOrg = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineSectorWideDetailOrg.vue'),
);
const SummaryArrgrateEstimateSTC = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/SummaryArrgrateEstimateSTC.vue'),
);

const ExamineSummaryReportSalaryDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineSummaryReportSalaryDetail.vue'),
);
const ReturnSectorWideDetailOrg = defineAsyncComponent(() =>
  import('@/views/return/popup/ReturnSectorWideDetailOrg.vue'),
);
const EstimateThreeYearExpenseInvestDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/CreateEstimate/popup/EstimateThreeYearExpenseInvestDetail.vue'),
);
const EstimateFinanceThreeYearRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/createEstimate/revenueOther/ThreeYearEstimateRevenueOtherDetail.vue'),
);
const UsingHelpInstruct = defineAsyncComponent(() => import('@/views/system/UsingHelpInstruct.vue'));

const SubmitThreeOrFiveYearEstimateDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/submitEstimate/SubmitThreeOrFiveYearEstimateDetail.vue'),
);
const AuditThreeOrFiveYearEstimateDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/submitEstimate/AuditThreeOrFiveYearEstimateDetail.vue'),
);
const SubmitEstArrgrateThreeYearNSNNDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/submitEstArrgrateThreeYear/SubmitEstArrgrateThreeYearNSNNDetail.vue'
  ),
);
// màn chi tiết thu hđsn, dv - nộp dự toán - 3 năm
const SubmitEstArrgrateThreeYearBusinessDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/submitEstArrgrateThreeYear/SubmitEstArrgrateThreeYearRevenueBusinessDetail.vue'
  ),
);
// màn chi tiết NỘP chi hđsn, dv - nộp dự toán - 3 năm
const SubmitEstArrgrateThreeYearFeeDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/submitEstArrgrateThreeYear/SubmitEstArrgrateThreeYearFeeDetail.vue'
  ),
);

const RequestSyncDicContentForm = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/tabs/popup/RequestSyncDicContentForm.vue'),
);

const ThreeYearExpenseProject = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateProject/expenseProject/ThreeYearExpenseProject.vue'
  ),
);

const ThreeYearEstimateProjectTab = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateProject/expenseProject/ThreeYearEstimateProjectTab.vue'
  ),
);

const SummaryArrgrateInvestSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/popups/SummaryArrgrateInvestSTCDetailPopup.vue'),
);

const SummaryArrgrateInvestSTCBudgetPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/popups/SummaryArrgrateInvestSTCBudgetPopup.vue'),
);

const SummaryArrgrateProjectSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/popups/SummaryArrgrateProjectSTCDetailPopup.vue'),
);
const SummaryArrgrateCalculationBasisSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/popups/SummaryArrgrateCalculationBasisSTCDetailPopup.vue'),
);
// màn chi tiết CTMT dự toán nhu cầu của ĐVCQ tại STC
const AuditEstArrgrateThreeYearProjectDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateArrgrateProject/AuditEstArrgrateThreeYearProjectDetail.vue'
  ),
);

const EstimateExpenseSalaryReform = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/salary/EstimateExpenseSalaryReform.vue'),
);

const BeforeDataRegularExpensePopup = defineAsyncComponent(() =>
  import('@/views/beforeData/beforeDataRegularExpense/BeforeDataRegularExpensePopup.vue'),
);

export function registerEstimate(app) {
  app.component('RevenueFeesDIPopup', SelectFeesDIPopup);
  app.component('EstimateFeesTab', EstimateFees);
  app.component('FeesRegularPopup', FeesRegularPopup);
  app.component('SettingContentLoanRepaymentPopup',SettingContentLoanRepaymentPopup);
  app.component('FeesExpenseInvestPopup', FeesExpenseInvestPopup);
  app.component('EstimateSubmitDetail', estimateSubmitDetail);
  app.component('EstimateThreeYearSubmitDetail', estimateThreeYearSubmitDetail);
  app.component('ThreeYearEstimateProjectExpenseDetailPopup', ThreeYearEstimateProjectExpenseDetailPopup);
  app.component('ThreeYearEstimateSTCProjectExpense', ThreeYearEstimateSTCProjectExpense);
  app.component('ThreeYearEstimateSTCBugdetCollection', ThreeYearEstimateSTCBugdetCollection);
  app.component('EsitmateSubmitFeedback', esitmateSubmitFeedback);
  app.component('EstimateAddContentPopup', EstimateAddContentPopup);
  app.component('EstimateThreeYearAddContentPopup', EstimateThreeYearAddContentPopup);
  app.component('EstimateTYAddContentPopup', EstimateTYAddContentPopup);
  app.component('EstimateBudgetDetail', estimateBudgetDetail);
  app.component('EstimateBudgetDetailPopup', estimateBudgetDetailPopup);
  app.component('SelectEstimateInformationPopup', SelectEstimateInformationPopup);
  app.component('SelectEstInitialInformationPopup', SelectEstInitialInformationPopup);
  app.component('DescribeHelperPopup', DescribeHelperPopup);
  app.component('templateShowValueTable', templateShowValueTable);
  app.component('EstimateRevenueOtherTab', EstimateRevenueOther);
  app.component('AddEstimateRevenueOtherPopup', AddEstimateRevenueOtherPopup);
  app.component('AddDictionaryRevenueOtherPopup', AddDictionaryRevenueOtherPopup);
  app.component('EstimateExpenseBusinessTab', EstimateExpenseBusiness);
  app.component('RevenueBusinessDIPopup', SelectBusinessDIPopup);
  app.component('BusinessRegularPopup', BusinessRegularPopup);
  app.component('BusinessExpenseInvestPopup', BusinessExpenseInvestPopup);
  app.component('SubmitDetailPopup', SubmitDetailPopup);
  app.component('EstimateArrgrateAddContentPopup', EstimateArrgrateAddContentPopup);
  app.component('EstimateArrgrateAddOrganizationPopup', EstimateArrgrateAddOrganizationPopup);
  app.component('UnitInfomationPopup', UnitInfomationPopup);
  app.component('EstimateSubmitRecNotifySuperiorPopup', EstimateSubmitRecNotifySuperiorPopup);
  app.component('EstimateSubmitInitialNotifyPopup', EstimateSubmitInitialNotifyPopup);
  app.component('EstimateSubmitThreeYearNotiPopup', EstimateSubmitThreeYearNotiPopup);
  app.component('EstimateSubmitFeedbackGeneralPopup', EstimateSubmitFeedbackGeneralPopup);
  app.component('EstimateThreeYearSubmitFeedbackGeneralPopup', EstimateThreeYearSubmitFeedbackGeneralPopup);
  app.component('EstimateSectorWideAddContentPopup', EstimateSectorWideAddContentPopup);
  app.component('ExamineSectorWideDetailOrg', ExamineSectorWideDetailOrg);
  app.component('ReturnSectorWideDetailOrg', ReturnSectorWideDetailOrg);
  app.component('EstimateThreeYearExpenseInvestDetail', EstimateThreeYearExpenseInvestDetail);
  app.component('EstimateFinanceThreeYearRevenueOtherDetail', EstimateFinanceThreeYearRevenueOtherDetail);
  app.component('UsingHelpInstruct', UsingHelpInstruct);
  app.component('SubmitThreeOrFiveYearEstimateDetail', SubmitThreeOrFiveYearEstimateDetail);
  app.component('AuditThreeOrFiveYearEstimateDetail', AuditThreeOrFiveYearEstimateDetail);
  app.component('AuditSuperiorFeedbackPopup', AuditSuperiorFeedbackPopup);
  app.component('RequestSyncDicContentForm', RequestSyncDicContentForm);
  app.component('WorkbookEditData', WorkbookEditData);
  app.component('ThreeYearExpenseProject', ThreeYearExpenseProject);
  app.component('ThreeYearEstimateProjectTab', ThreeYearEstimateProjectTab);
  app.component('SubmitEstArrgrateThreeYearNSNNDetail', SubmitEstArrgrateThreeYearNSNNDetail);
  app.component('SubmitEstArrgrateThreeYearBusinessDetail', SubmitEstArrgrateThreeYearBusinessDetail);
  app.component('SubmitEstArrgrateThreeYearFeeDetail', SubmitEstArrgrateThreeYearFeeDetail);
  app.component('SummaryArrgrateInvestSTCDetailPopup', SummaryArrgrateInvestSTCDetailPopup);
  app.component('SummaryArrgrateInvestSTCBudgetPopup', SummaryArrgrateInvestSTCBudgetPopup);
  app.component('SummaryArrgrateProjectSTCDetailPopup', SummaryArrgrateProjectSTCDetailPopup);
  app.component('SummaryArrgrateCalculationBasisSTCDetailPopup', SummaryArrgrateCalculationBasisSTCDetailPopup);
  app.component('SummaryArrgrateEstimateSTC', SummaryArrgrateEstimateSTC);
  app.component('ExamineSummaryReportSalaryDetail', ExamineSummaryReportSalaryDetail);
  app.component('AuditEstArrgrateThreeYearProjectDetail', AuditEstArrgrateThreeYearProjectDetail);
  app.component('EstimateExpenseSalaryReform', EstimateExpenseSalaryReform);
  app.component('beforeDataRegularExpensePopup', BeforeDataRegularExpensePopup);
}
